import { Util } from './_util.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import Swiper from 'swiper/bundle';
import Headroom from 'headroom.js';
import Cookies from 'js-cookie';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

var device = 'mobile';
$(window)
  .on('resize', function () {
    var windowWidth = $(window).outerWidth();
    if (windowWidth < 760) {
      if (device == 'desktop') {
        $('.module--shop-all-collections__filter-label--active').removeClass('module--shop-all-collections__filter-label--active');
        $('.module--shop-all-collections__filter-title--active').removeClass('module--shop-all-collections__filter-title--active');
        $('.module--shop-all-collections__filter-groups').hide();
        $('.module--shop-all-collections__filter-dropdown').hide();
        device = 'mobile';
      }
    } else {
      if (device == 'mobile') {
        $('.module--shop-all-collections__filter-label--active').removeClass('module--shop-all-collections__filter-label--active');
        $('.module--shop-all-collections__filter-title--active').removeClass('module--shop-all-collections__filter-title--active');
        $('.module--shop-all-collections__filter-groups').show();
        $('.module--shop-all-collections__filter-dropdown').hide();
        device = 'desktop';
      }
    }
  })
  .resize();

const App = {
  checkTouchDevice: function () {
    if ('ontouchstart' in document.documentElement) {
      $('body').addClass('touch-device');
    } else {
      $('body').addClass('no-touch-device');
    }
  },

  controlAgeGate: function () {
    (function () {
      const COOKIE_NAME = 'ehlers_age_verified';
      const COOKIE_DAYS = 7;
      const ageGate = document.querySelectorAll('.age-gate');
      const enterButton = document.querySelectorAll('.age-gate__confirm');
      const FOCUSABLE_SELECTORS = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

      if (!ageGate.length || !enterButton.length) return;

      // --- Cookie Helpers ---
      function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = 'expires=' + date.toUTCString();
        document.cookie = name + '=' + value + ';' + expires + ';path=/;SameSite=Lax';
      }

      function getCookie(name) {
        const nameEQ = name + '=';
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          let c = cookies[i].trim();
          if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length);
          }
        }
        return null;
      }

      // --- Focus Trap ---
      function trapFocus(gate, e) {
        const focusable = Array.from(gate.querySelectorAll(FOCUSABLE_SELECTORS));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }

      // --- Open Gate ---
      function openGate(gate) {
        gate.classList.add('age-gate-open');
        gate.setAttribute('aria-hidden', 'false');

        const firstFocusable = gate.querySelector(FOCUSABLE_SELECTORS);
        if (firstFocusable) firstFocusable.focus();

        gate._trapHandler = function (e) {
          if (e.key === 'Tab') trapFocus(gate, e);
          if (e.key === 'Escape') closeGate(gate);
        };
        gate.addEventListener('keydown', gate._trapHandler);
      }

      // --- Close Gate ---
      function closeGate(gate) {
        setCookie(COOKIE_NAME, 'true', COOKIE_DAYS);

        var root = document.getElementsByTagName('html')[0];
        root.removeAttribute('class');

        gate.classList.remove('age-gate-open');
        gate.setAttribute('aria-hidden', 'true');

        if (gate._trapHandler) {
          gate.removeEventListener('keydown', gate._trapHandler);
          gate._trapHandler = null;
        }

        const skipLink = document.querySelector('.skip-link');
        const firstPageFocusable = skipLink || document.querySelector(FOCUSABLE_SELECTORS);
        if (firstPageFocusable) firstPageFocusable.focus();
      }

      // --- Show Modal if Cookie Not Set ---
      if (!getCookie(COOKIE_NAME)) {
        var root = document.getElementsByTagName('html')[0];
        root.setAttribute('class', 'hidden');
        ageGate.forEach(function (gate) {
          openGate(gate);
        });
      }

      // --- Handle Enter Click ---
      enterButton.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const gate = btn.closest('.age-gate');
          if (gate) {
            closeGate(gate);
          } else {
            ageGate.forEach(function (g) {
              closeGate(g);
            });
          }
        });
      });
    })();
  },

  controlHeader: function () {
    const header = document.querySelector('header');
    const headroom = new Headroom(header);
    headroom.init();
  },

  controlMainMenu: function () {
    function openMainMenu() {
      $('.header').addClass('header--open');
      $('.header__nav').addClass('header__nav--open');
      $('.header__toggle').addClass('header__toggle--close');
      $('.header__nav').scrollTop(0);
      $('html').addClass('hidden');
    }

    function closeMainMenu() {
      $('.header').removeClass('header--open');
      $('.header__nav').removeClass('header__nav--open');
      $('.header__toggle').removeClass('header__toggle--close');
      $('.header__nav-bg-img--current').removeClass('header__nav-bg-img--current');
      $('html').removeClass('hidden');
    }

    $('.header__toggle').on('click', function () {
      if ($(this).hasClass('header__toggle--close')) {
        closeMainMenu();
      } else {
        openMainMenu();
      }
    });

    $('.no-touch-device .header__nav-item').on('mouseenter', function () {
      const $item = $(this);
      const itemIndex = $item.index();
      const $bgImages = $('.header__nav-bg .header__nav-bg-img');
      $bgImages.removeClass('header__nav-bg-img--current');
      $bgImages.eq(itemIndex).addClass('header__nav-bg-img--current');
    });
  },

  controlHero: function () {
    $('.module--big-hero__scroll-down').on('click', function (e) {
      e.preventDefault();
      const targetElement = $(this).parents('.module').next(),
        elementPosition = targetElement.offset().top;
      $('html, body').animate({ scrollTop: elementPosition }, 600, 'swing');
    });
  },

  controlVideo: function () {
    $('.module--single-wine__details-highlight-play-btn').on('click', function () {
      const $btn = $(this);
      const $videoWrap = $btn.siblings('.module--single-wine__details-highlight-video');
      const video = $videoWrap.find('video')[0];

      if (!video) return;

      $btn.fadeOut(300);
      $videoWrap.fadeIn(300);
      video.play();

      $(video).one('ended', function () {
        $videoWrap.fadeOut(300);
        $btn.fadeIn(300);
      });
    });
  },

  filterShopAllCollections: function () {
    $(document).ready(function () {
      var hash = window.location.hash;
      if (hash) {
        var cleanHash = hash.substring(1),
          targetButton = $('[data-id="' + cleanHash + '"]');
        if (targetButton.length) {
          targetButton.trigger('click');
        }
        history.replaceState(null, null, window.location.pathname + window.location.search);
      }
    });

    $('.module--shop-all-collections__filter-title').on('click', function (e) {
      e.preventDefault();
      if ($(this).hasClass('module--shop-all-collections__filter-title--active')) {
        $(this).removeClass('module--shop-all-collections__filter-title--active');
        $('.module--shop-all-collections__filter-groups').fadeOut(300);
      } else {
        $(this).addClass('module--shop-all-collections__filter-title--active');
        $('.module--shop-all-collections__filter-groups').fadeIn(300);
        $('.module--shop-all-collections__filter-label--active').removeClass('module--shop-all-collections__filter-label--active');
        $('.module--shop-all-collections__filter-dropdown').hide();
      }
    });

    $('.module--shop-all-collections__filter-label').on('click', function (e) {
      e.preventDefault();
      if ($(this).hasClass('module--shop-all-collections__filter-label--active')) {
        $(this).removeClass('module--shop-all-collections__filter-label--active');
        if (device == 'mobile') {
          $(this).siblings('.module--shop-all-collections__filter-dropdown').slideUp(300);
        } else {
          $(this).siblings('.module--shop-all-collections__filter-dropdown').fadeOut(300);
        }
      } else {
        $(this).addClass('module--shop-all-collections__filter-label--active');
        $('.module--shop-all-collections__filter-label').not(this).removeClass('module--shop-all-collections__filter-label--active');
        if (device == 'mobile') {
          $(this).siblings('.module--shop-all-collections__filter-dropdown').slideDown(300);
          $('.module--shop-all-collections__filter-label').not(this).siblings('.module--shop-all-collections__filter-dropdown').slideUp(300);
        } else {
          $(this).siblings('.module--shop-all-collections__filter-dropdown').fadeIn(300);
          $('.module--shop-all-collections__filter-label').not(this).siblings('.module--shop-all-collections__filter-dropdown').fadeOut(300);
        }
      }
    });

    // Prevent C7 login/cart buttons and quantity inputs inside card anchors from triggering navigation.
    // We intercept at the <a> level so C7's own listeners (including document-delegated ones) still fire.
    $('.module--shop-all-collections__grid-item, .module--single-wine__recommended-products-item').on('click', function (e) {
      var $target = $(e.target);
      var $cart = $target.closest('.c7-product__add-to-cart');
      if (!$target.closest('.c7-product__login-message').length && !$cart.length) {
        return;
      }

      // Stop the surrounding card anchor from navigating.
      e.preventDefault();

      // The Add to Cart control is a submit button and C7 adds to cart via the
      // form's `submit` event. Preventing the click default above also cancels
      // the implicit form submission, so re-dispatch it here to let C7's own
      // submit handler run the AJAX add-to-cart.
      if ($cart.length && $target.closest('button[type="submit"]').length) {
        var form = $cart.is('form') ? $cart[0] : $cart.find('form')[0];
        if (form) {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit($target.closest('button')[0]);
          } else {
            form.submit();
          }
        }
      }
    });

    $('.module--shop-all-collections__filter-dropdown-btn').on('click', function (e) {
      e.preventDefault();
      var filter = $(this).attr('data-id');
      if (!$(this).hasClass('module--shop-all-collections__filter-dropdown-btn--current')) {
        $(this).addClass('module--shop-all-collections__filter-dropdown-btn--current');
        $('.module--shop-all-collections__filter-dropdown-btn').not(this).removeClass('module--shop-all-collections__filter-dropdown-btn--current');
        $('.module--shop-all-collections__grid-title').hide().removeClass('module--shop-all-collections__grid-title--active');
        $('.module--shop-all-collections__grid-title.' + filter).show();
        $('.module--shop-all-collections__grid-item').hide().removeClass('module--shop-all-collections__grid-item--active');
        $('.module--shop-all-collections__grid-item.' + filter).show();
        setTimeout(function () {
          $('.module--shop-all-collections__grid-title.' + filter).addClass('module--shop-all-collections__grid-title--active');
          $('.module--shop-all-collections__grid-item.' + filter).addClass('module--shop-all-collections__grid-item--active');
        }, 100);
        if ($(this).hasClass('module--shop-all-collections__filter-dropdown-btn--vintages') || $(this).hasClass('module--shop-all-collections__filter-dropdown-btn--other-selections')) {
          $('.module--shop-all-collections__grid-title--placeholder').html($(this).text()).show();
          setTimeout(function () {
            $('.module--shop-all-collections__grid-title--placeholder').addClass('module--shop-all-collections__grid-title--active');
          }, 100);
        }
        $('.module--shop-all-collections__filter-title--active').removeClass('module--shop-all-collections__filter-title--active');
        $('.module--shop-all-collections__filter-label--active').removeClass('module--shop-all-collections__filter-label--active');
        if (device == 'mobile') {
          $('.module--shop-all-collections__filter-groups').fadeOut(300);
        } else {
          $('.module--shop-all-collections__filter-dropdown').fadeOut(300);
        }
      }
    });
  },

  filterPosts: function () {
    $(document).ready(function () {
      var hash = window.location.hash;
      if (hash) {
        var cleanHash = hash.substring(1),
          targetButton = $('[data-id="' + cleanHash + '"]');
        if (targetButton.length) {
          targetButton.trigger('click');
        }
        history.replaceState(null, null, window.location.pathname + window.location.search);
      }
    });

    $('.module--post-grid__filter-btn').on('click', function (e) {
      e.preventDefault();
      var filter = $(this).attr('data-id');
      if (!$(this).hasClass('module--post-grid__filter-btn--current')) {
        $(this).addClass('module--post-grid__filter-btn--current');
        $('.module--post-grid__filter-btn').not(this).removeClass('module--post-grid__filter-btn--current');
        $('.module--post-grid__item').hide().removeClass('module--post-grid__item--active');
        $('.module--post-grid__item.' + filter).show();
        setTimeout(function () {
          $('.module--post-grid__item.' + filter).addClass('module--post-grid__item--active');
        }, 100);
      }
    });
  },

  initSwipers: function () {
    $('.module--banner-overlay__background--carousel').each(function () {
      const $module = $(this);

      new Swiper($module[0], {
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 'auto',
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        parallax: true,
        speed: 600,
        loop: true,
        grabCursor: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        simulateTouch: false,
        allowTouchMove: false,
      });
    });

    $('.module--content-carousel__cards').each(function () {
      const $module = $(this);
      const navigationVar = 's' + Math.floor(Math.random() * 1400);
      $module.find('.swiper-pagination').addClass(navigationVar);

      new Swiper($module[0], {
        centeredSlides: false,
        spaceBetween: 0,
        slidesPerView: 'auto',
        effect: 'slide',
        parallax: true,
        speed: 600,
        loop: true,
        grabCursor: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        simulateTouch: true,
        allowTouchMove: true,
        pagination: {
          el: '.swiper-pagination.' + navigationVar,
          clickable: true,
        },
      });
    });

    $('.module--collections-slider__collections').each(function (index) {
      const $module = $(this);

      new Swiper($module[0], {
        centeredSlides: false,
        spaceBetween: 0,
        slidesPerView: 'auto',
        effect: 'slide',
        parallax: true,
        speed: 600,
        loop: false,
        grabCursor: false,
        autoplay: false,
        simulateTouch: true,
        allowTouchMove: true,
      });
    });

    $('.module--detail-split__primary-image').each(function () {
      const $module = $(this);

      new Swiper($module[0], {
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 'auto',
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        parallax: true,
        speed: 600,
        loop: true,
        grabCursor: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        simulateTouch: false,
        allowTouchMove: false,
      });
    });

    $('.module--testimonials-slider__track').each(function () {
      const $module = $(this);
      const navigationVar = 's' + Math.floor(Math.random() * 100000);
      $module.find('.swiper-pagination').addClass(navigationVar);

      new Swiper($module[0], {
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 'auto',
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        parallax: true,
        speed: 600,
        loop: true,
        grabCursor: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        simulateTouch: true,
        allowTouchMove: true,
        pagination: {
          el: '.swiper-pagination.' + navigationVar,
          clickable: true,
        },
      });
    });

    $('.module--content-carousel__timeline').each(function (index) {
      const $module = $(this);
      const navigationVar = 's' + Math.floor(Math.random() * 123);
      $module.find('.swiper-button').addClass(navigationVar);

      const swiper = new Swiper($module[0], {
        centeredSlides: false,
        spaceBetween: 0,
        slidesPerView: 'auto',
        effect: 'slide',
        parallax: true,
        speed: 600,
        loop: false,
        grabCursor: true,
        autoplay: false,
        simulateTouch: true,
        allowTouchMove: true,
        navigation: {
          prevEl: '.swiper-button--previous.' + navigationVar,
          nextEl: '.swiper-button--next.' + navigationVar,
        },
      });
    });

    const initFeaturedCardsSwiper = (swiperEl) => {
      const $module = $(swiperEl);
      const navigationVar = 's' + Math.floor(Math.random() * 1456);
      $module.find('.swiper-button').addClass(navigationVar);

      let swiper = null;

      const init = () => {
        if (swiper) return;

        swiper = new Swiper($module[0], {
          centeredSlides: false,
          spaceBetween: 30,
          slidesPerView: 'auto',
          effect: 'slide',
          parallax: true,
          speed: 600,
          loop: true,
          grabCursor: true,
          autoplay: false,
          simulateTouch: true,
          allowTouchMove: true,
          navigation: {
            prevEl: '.swiper-button--previous.' + navigationVar,
            nextEl: '.swiper-button--next.' + navigationVar,
          },
        });
      };

      const destroy = () => {
        if (!swiper) return;
        swiper.destroy(true, true);
        swiper = null;
      };

      const mq = window.matchMedia('(max-width: 539px)');

      const check = () => {
        if (mq.matches) {
          init();
        } else {
          destroy();
        }
      };

      check();

      mq.addEventListener('change', check);

      let resizeTimer = null;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(check, 150);
      });
    };

    $('.module--team-grid__team, .module--single-wine__recommended-products-grid').each(function (index) {
      initFeaturedCardsSwiper(this);
    });

    // Handle statically rendered featured cards swipers
    $('.module--featured-cards__cards').each(function () {
      initFeaturedCardsSwiper(this);
    });

    // Watch for dynamically injected featured cards swipers (e.g. C7 personalization)
    document.querySelectorAll('.module--featured-cards').forEach((section) => {
      if (section.querySelector('.module--featured-cards__cards')) return;

      const observer = new MutationObserver(() => {
        const swiperEl = section.querySelector('.module--featured-cards__cards');
        if (swiperEl && !swiperEl.dataset.swiperInitialized) {
          swiperEl.dataset.swiperInitialized = 'true';
          observer.disconnect();
          initFeaturedCardsSwiper(swiperEl);
        }
      });

      observer.observe(section, { childList: true, subtree: true });
    });
  },

  initGSAP: function () {
    const sections = document.querySelectorAll('section.module--highlight-split');
    const main = document.querySelector('.main');

    if (!sections.length || !main) return;

    const defaultBg = main.getAttribute('data-background-color') || '';

    sections.forEach((section, index) => {
      const bgColor = section.dataset.backgroundColor;
      if (!bgColor) return;

      const isLast = index === sections.length - 1;
      const isFirst = index === 0;

      ScrollTrigger.create({
        trigger: section,
        start: 'top center',
        end: 'bottom center',

        onEnter: () => {
          main.setAttribute('data-background-color', bgColor);
        },

        onEnterBack: () => {
          main.setAttribute('data-background-color', bgColor);
        },

        onLeave: () => {
          if (isLast) {
            if (defaultBg) {
              main.setAttribute('data-background-color', defaultBg);
            } else {
              main.removeAttribute('data-background-color');
            }
          }
        },

        onLeaveBack: () => {
          if (isFirst) {
            if (defaultBg) {
              main.setAttribute('data-background-color', defaultBg);
            } else {
              main.removeAttribute('data-background-color');
            }
          }
        },
      });
    });
  },

  getCopyrightYear: function () {
    const currentTime = new Date(),
      currentYear = currentTime.getFullYear();
    $('.footer .year').html(currentYear);
  },

  handleTempC7Redirects: function () {
    const redirects = {
      '/collection/all-wines/': '/wine',
      '/wine-clubs/': '/experiences/wine-club',
      '/reservation/': '/experiences/events/',
    };

    function checkAndRedirect() {
      const destination = redirects[window.location.pathname];
      if (destination) {
        window.location.replace(destination);
      }
    }

    // Patch pushState / replaceState so SPA navigations are intercepted
    ['pushState', 'replaceState'].forEach(function (method) {
      const original = history[method];
      history[method] = function (state, title, url) {
        original.apply(this, arguments);
        if (url) {
          const path = new URL(url, window.location.href).pathname;
          const destination = redirects[path];
          if (destination) {
            window.location.replace(destination);
          }
        }
      };
    });

    // Handle browser back/forward
    window.addEventListener('popstate', checkAndRedirect);

    // Check on initial load
    checkAndRedirect();
  },
  c7LoginCheck: function () {
    let C7tenant = 'ehlers-estate';

    let customerToken = Cookies.get('customerToken');

    if (typeof customerToken === 'undefined') {
      localStorage.setItem('loginStatus', null);
      window.c7User = null;
      App.c7WpLogoutBridge();
      return;
    }

    fetch(`https://api.commerce7.com/v1/customer/self`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        tenant: C7tenant,
        authorization: customerToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.id) {
          window.c7User = data;
          localStorage.setItem('loginStatus', 'loggedIn');
          App.c7WpAuthBridge(customerToken);
        } else {
          localStorage.setItem('loginStatus', null);
          window.c7User = null;
        }
      })
      .catch(() => {
        localStorage.setItem('loginStatus', null);
        window.c7User = null;
      });
  },

  /**
   * After a successful C7 auth, silently establish a WP session via the
   * server-side bridge endpoint. Only fires when:
   *   1. The c7Bridge object is localized on the page (single posts only).
   *   2. The #comments-gate sentinel is present (i.e. WP session not yet set).
   * On success the page reloads once so the server renders wpDiscuz with a
   * logged-in WP session.
   */
  c7WpAuthBridge: function (customerToken) {
    if (typeof c7Bridge === 'undefined') return;
    if (!document.getElementById('comments-gate')) return;

    const formData = new FormData();
    formData.append('action', 'c7_auth_bridge');
    formData.append('nonce', c7Bridge.nonce);
    formData.append('customerToken', customerToken);

    fetch(c7Bridge.ajaxUrl, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success && result.data.reload) {
          window.location.reload();
        }
      })
      .catch(() => {});
  },

  /**
   * When the C7 session is gone, silently log out the WP subscriber session
   * so the two sessions stay in sync. Only fires when:
   *   1. c7Bridge is localized (single posts only).
   *   2. c7Bridge.wpLoggedIn is true (WP session is currently active).
   * The server-side handler only acts on C7-provisioned accounts — admins
   * and non-C7 WP users are never affected.
   */
  c7WpLogoutBridge: function () {
    if (typeof c7Bridge === 'undefined') return;
    if (!c7Bridge.wpLoggedIn) return;

    const formData = new FormData();
    formData.append('action', 'c7_logout_bridge');
    formData.append('nonce', c7Bridge.nonce);

    fetch(c7Bridge.ajaxUrl, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success && result.data.reload) {
          window.location.reload();
        }
      })
      .catch(() => {});
  },

  init: function () {
    this.checkTouchDevice();
    this.controlAgeGate();
    this.controlHeader();
    this.controlMainMenu();
    this.controlHero();
    this.controlVideo();
    this.filterShopAllCollections();
    this.filterPosts();
    this.initSwipers();
    this.initGSAP();
    this.getCopyrightYear();
    this.handleTempC7Redirects();
    this.c7LoginCheck();
  },
};

export default App;
